import { models } from "./models.js";

// Estimated speed category for each model (lower = faster)
const MODEL_SPEED_RANK = {
  "gpt-5-nano": 1,
  "gpt-5-mini": 2,
  "gpt-5": 3,
  latest: 3,
  "o4-mini": 4,
  o3: 4,
  "gpt-4o": 5,
  "gpt-4.1": 5,
  "gpt-3.5-turbo": 6,
};

// Base values for the fastest model
const BASE_SPEED_MS = 1400;   // placeholder rotation
const BASE_DELAY_MS = 70;     // per-character typing

// How much slower each step in rank is
const SPEED_STEP = 150;       // extra ms per placeholder rotation
const DELAY_STEP = 8;         // extra ms per character

// Default placeholders
const DEFAULT = {
  placeholders: ["Thinking…", "Processing your request…", "Drafting a response…"],
};

// Extra fancy placeholders per model
const CUSTOM_PLACEHOLDERS = {
  latest: [
    "Reasoning deeply…", "Thinking…", "Parsing your context…", "Evaluating edge cases…", "Drafting a precise answer…"
  ],
  "gpt-5": [
    "Reasoning deeply…", "Verifying details…", "Composing a concise answer…", "Refining wording…"
  ],
  "gpt-5-mini": ["Thinking…", "Drafting…", "Polishing…"],
  "gpt-5-nano": ["Thinking…", "Typing…"],
  "o4-mini": ["Reasoning step-by-step…", "Testing assumptions…", "Summarising clearly…"],
  o3: ["Planning…", "Outlining…", "Answering…"],
  "gpt-4.1": ["Reviewing details…", "Formulating response…", "Ensuring clarity…"],
  "gpt-4o": ["Processing input…", "Organising thoughts…", "Drafting…"],
  "gpt-3.5-turbo": ["Thinking…", "Formulating reply…"],
};

// Generate REGISTRY dynamically
const REGISTRY = models.reduce((map, m) => {
  const rank = MODEL_SPEED_RANK[m.value] ?? 3; // fallback rank if missing
  map[m.value] = {
    placeholders: CUSTOM_PLACEHOLDERS[m.value] || DEFAULT.placeholders,
    speedMs: BASE_SPEED_MS + (rank - 1) * SPEED_STEP,
    streamDelayMs: BASE_DELAY_MS + (rank - 1) * DELAY_STEP,
  };
  return map;
}, {});

// Helper to safely get persona by model key (fallback to 'latest' then DEFAULT)
export function getPersona(model) {
  const key = model || "latest";
  return REGISTRY[key] || REGISTRY.latest || {
    placeholders: DEFAULT.placeholders,
    speedMs: BASE_SPEED_MS,
    streamDelayMs: BASE_DELAY_MS,
  };
}
